<template>
  <div class="videoresume" :class="['videoresume-' + videoOrientaion]" id="videoresume">
    <!-- <div>loadedPlayer: {{loadedPlayer}}</div>
      <div>loading: {{loading}}</div>
    -->

    <div v-if="loading" class="loading">{{ $tr('common.loading') }}</div>

    <div v-else-if="error" class="error">{{ error }}</div>
    <div v-else class="pub_page_wrapper" :class="{ pub_page__visible: loadedPlayer && !loading }">
      <div class="videoresume-top" :class="['videoresume-top--' + videoOrientaion]">
        <a class="videoresume-logo" :href="vcvMeLink" target="_blank" rel="noopener">
          <img :src="companyLogo" class="vlogo" />
        </a>

        <span class="videoresume-date">{{ responseDate }}</span>
      </div>
      <div class="pub_page" :class="['pub_page-' + videoOrientaion]">
        <div class="videoresume-header">
          <div class="name-block" v-if="full_name">
            <div class="name">{{ full_name }}</div>
          </div>

          <div class="contacts_block" v-if="vacancyName">
            <div class="vacancy_name">{{ vacancyName }}</div>
          </div>
        </div>

        <!-- <div class="videoresume-content"> -->
        <div class="videoresume-left-block" ref="left_block">
          <div class="vcontent">
            <span class="videoresume-date videoresume-date--mobile">{{ responseDate }}</span>

            <div v-if="has_answers" id="vblock" ref="vblock" class="vblock">
              <template v-if="!isIos && !isSafari">
                <player
                  v-if="video"
                  ref="player"
                  :src="video ? video.source : ''"
                  :poster="video ? video.preview : ''"
                  :muted="config.muted"
                  :rate="config.rate"
                  :index="num"
                  :volume="config.volume"
                  is-fluid
                  :height="videoHeight || 0"
                  class="response-player is-mirror"
                  @changed="save_config"
                  @player_state_changed="player_state_changed"
                  @onPlayerLoadeddata="onPlayerLoadeddata($event, num)"
                  @ended="next_answer"
                  @play="set_answer_state(num, true)"
                  @paused="set_answer_state(num, false)"
                  @error="playerError"
                />

                <div v-else>
                  <div class="dummy">
                    <img src="/static/images/elements/dummy-video.svg" />
                    <div class="dummy-description">
                      {{ dummy_video_description }}
                    </div>
                  </div>
                </div>
              </template>

              <template v-else>
                <div v-for="(question, index) in response.questions" :key="question.id" @contextmenu.prevent>
                  <vrecursive-block
                    v-if="!is_video_started && !first_click_was"
                    class="recursive-block"
                    :count="response.questions.length - 1"
                    :current_index="index"
                    :handle_click="first_play_click"
                  >
                    <div class="play_first">play</div>
                  </vrecursive-block>

                  <player
                    v-if="!is_not_video(question)"
                    :ref="'player_' + index"
                    :class="{
                      vphide: num !== index,
                      'response-player-vertical': videoOrientaion === 'vertical'
                    }"
                    :src="question.video ? question.video.source : ''"
                    :poster="question.video ? question.video.preview : ''"
                    :muted="config.muted"
                    :rate="config.rate"
                    :index="index"
                    :volume="config.volume"
                    is-fluid
                    class="response-player response-player-safari is-mirror"
                    @ready="readyPlayer"
                    @player_state_changed="player_state_changed"
                    @onPlayerLoadeddata="onPlayerLoadeddata($event, index)"
                    @inited="set_controls"
                    @changed="save_config"
                    @ended="next_answer"
                    @play="set_answer_state(index, true)"
                    @paused="set_answer_state(index, false)"
                    @error="playerError"
                  />

                  <div v-else :class="{ vphide: num !== index }">
                    <div class="dummy">
                      <img src="/static/images/elements/dummy-video.svg" />
                      <div class="dummy-description">
                        {{ dummy_video_description }}
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
        <div class="videoresume-right-block">
          <div class="videoresume-nav">
            <div class="top-tabs">
              <vresume-paginator
                :options="tabs"
                :has-application-tab="tabApplicationListHasAnswers"
                :active-tab="activeTab.id"
                @updateTab="updateTab"
              />
            </div>

            <div v-if="resumeLinkFile || resumeLinkUrl" class="videoresume-contacts cv-row">
              <a
                v-if="resumeLinkFile"
                v-tooltip="{
                  content: $tr('videoresume.myResume'),
                  placement: 'left',
                  classes: 'cv-tooltip cv-tooltip--videoresume'
                }"
                class="cv-row-resume-link"
                :href="resumeLinkFile"
                target="_blank"
                rel="noopener"
              >
                <icon-cv />
              </a>

              <a
                v-if="resumeLinkUrl"
                v-tooltip="{
                  content: resumeLinkUrlText,
                  placement: 'left',
                  classes: 'cv-tooltip cv-tooltip--videoresume'
                }"
                class="cv-row-resume-link"
                :href="resumeLinkUrl"
                target="_blank"
                rel="noopener"
              >
                <icon-link />
              </a>
            </div>
          </div>

          <div class="vcontent-wrap">
            <div
              class="vcontent vcontent--tabs"
              :class="[contentScrolledTo, hasContentScroll ? 'has-scroll' : '']"
              ref="tab_content"
            >
              <tab-questions
                v-if="activeTab.id === 'answers'"
                is-videoresume
                :questions="response.questions"
                :response-id="response.id"
                :question-index="questionIndex"
                :durations="durations"
                :current-time="currentTime"
                @set_active_answer="set_active_answer"
              />
              <vresume-about-me
                v-if="activeTab.id === 'application' && tabApplicationListHasAnswers"
                :list="tabApplicationList"
                is-linkify
              />

              <div v-if="activeTab.id === 'resume'" class="tab-resume">
                <a v-if="resumeLinkFile" class="cv-row-mobile" :href="resumeLinkFile" target="_blank" rel="noopener">
                  <icon-cv class="cv-row-mobile__file" />

                  <span class="cv-row-mobile__text">{{ $tr('videoresume.myResume') }}</span>
                </a>

                <a v-if="resumeLinkUrl" class="cv-row-mobile" :href="resumeLinkUrl" target="_blank" rel="noopener">
                  <icon-link class="cv-row-mobile__link" />

                  <span class="cv-row-mobile__text">{{ resumeLinkUrlText }}</span>
                </a>
              </div>
            </div>
          </div>

          <div class="videoresume-footer">
            <vresume-button
              class="videoresume-footer__button"
              :text="$tr('videoresume.contactMe')"
              :is_large="true"
              @click="showModal"
            />
          </div>
        </div>
        <!-- </div> -->
      </div>
    </div>

    <vresume-modal :is-modal-open="isModalVisible" @closeModal="hideModal">
      <template slot="modal_content">
        <div class="videoresume-modal__header">
          <h3 class="videoresume-modal__h">
            {{ $tr('videoresume.contactMe') }}
          </h3>
        </div>

        <div class="videoresume-modal__body">
          <ul class="videoresume-modal__list">
            <li v-if="candidatePhone" class="videoresume-modal__item">
              <a class="videoresume-modal__link" :href="'tel:' + candidatePhone" target="_blank" rel="noopener">
                <div class="videoresume-modal__icon">
                  <icon-phone />
                </div>

                <span class="videoresume-modal__text">{{ candidatePhone }}</span>
              </a>
            </li>
            <li v-if="candidateEmail" class="videoresume-modal__item">
              <a class="videoresume-modal__link" :href="'mailto:' + candidateEmail" target="_blank" rel="noopener">
                <div class="videoresume-modal__icon">
                  <icon-mail />
                </div>

                <span class="videoresume-modal__text">{{ candidateEmail }}</span>
              </a>
            </li>
            <!-- <li class="videoresume-modal__item" v-if="linkedinLink">
              <a
                class="videoresume-modal__link"
                :href="linkedinLink"
                target="_blank"
                rel="noopener"
              >
                <div class="videoresume-modal__icon">
                  <icon-linkedin />
                </div>
                <span class="videoresume-modal__text">{{
                  linkedinLinkText
                }}</span>
              </a>
            </li> -->
          </ul>
        </div>
      </template>
    </vresume-modal>
  </div>
</template>

<script>
import basic from './default.vue';
// import Axios from 'axios';
import moment from 'moment';
import { mapState } from 'vuex';
// import intersection from 'lodash/intersection';
import VueScrollTo from 'vue-scrollto';

import TabQuestions from './components/TabVideoresumeQuestions.vue';
import TabApplication from './components/TabVideoresumeApplication.vue';
import player from '@/routes_new/inner/response/components/player.vue';
import SafariBrowserDetector from '@/components/mixin/SafariBrowserDetector.js';
import vpaginator from '@/routes_new/inner/response/components/video_paginator.vue';
import VideoPlayer from '@/components/VideoPlayer.vue';

export default {
  name: 'Videoresume',

  components: {
    default: basic,
    TabQuestions,
    TabApplication,
    player,
    vpaginator,
    VideoPlayer
  },

  mixins: [SafariBrowserDetector],

  props: ['response', 'responseToken', 'error', 'vcvMeLink'],

  data() {
    return {
      loading: true,
      refresh: true,
      controls: [],
      num: 0,
      tabChanged: false,
      catched: false,
      top_poistion: null,
      playclick_count: 0,
      volume: 1,
      muted: false,
      tabChanged: false,
      defaultPlaybackRate: 1,
      isModalVisible: false,
      contentScrolledTo: 'top',
      hasContentScroll: false,
      durations: [],
      currentTime: 0,
      loadedPlayer: false,
      blockWidth: 0,
      config: {
        muted: false,
        rate: 1,
        volume: 1
      },
      tabItems: [
        {
          id: 'answers',
          title: this.$tr('videoresume.questions')
        },
        {
          id: 'application',
          title: this.$tr('videoresume.aboutMe')
        },
        {
          id: 'resume',
          title: this.$tr('videoresume.resume'),
          isMobile: true
        }
      ],
      activeTab: {
        id: 'answers',
        title: this.$tr('videoresume.questions')
      },
      player_loadeddata: false
    };
  },

  computed: {
    ...mapState(['locale']),
    first_num_with_video() {
      let result = 0;
      let list = this.response.questions.map(i => i.video);
      for (let i = 0; i < list.length; i++) {
        if (list[i] !== null) {
          result = i;
          break;
        }
      }
      return result;
    },

    tabs() {
      if (this.resumeLinkFile || this.resumeLinkUrl) {
        return this.tabItems;
      }
      return this.tabItems.filter(item => item.id !== 'resume');
    },

    last_num_with_video() {
      let result = 0;
      let list = this.response.questions.map(i => i.video);
      for (let i = list.length - 1; i >= 0; i--) {
        if (list[i] !== null) {
          result = i;
          break;
        }
      }
      return result;
    },

    resumeLinkFile() {
      return this.response ? this.response.resume_url : null;
    },

    resumeLinkUrl() {
      let url = this.response ? this.response.second_resume_url : null;

      if (url && url.indexOf('http') !== 0) {
        url = `http://${url}`;
      }
      return url;
    },

    resumeLinkUrlText() {
      return this.response && this.response.second_resume_url
        ? this.response.second_resume_url
            .replace(/<[^>]*>?/gm, '')
            .replace(/^https?\:\/\//i, '')
            .replace(/^www\./i, '')
        : null;
    },

    responseDate() {
      if (!this.response || !this.response.date_sent) {
        return '';
      }
      const day = moment(this.response.date_sent, 'YYYY-MM-DDThh:mm', this.locale.value);

      if (!day) {
        return '';
      }

      return day.format('LL');
    },

    companyLang() {
      if (!this.response || !this.response.company || !this.response.company.language) {
        return null;
      }

      return this.response.company.language.code;
    },

    companyLogo() {
      if (!this.response || !this.response.company || !this.response.company.logo) {
        return '/static/images/elements/vcv-videoresume.svg';
      }

      return this.response.company.logo;
    },

    isCandidateLink() {
      return this.response && this.response.is_candidate_link;
    },

    questions() {
      if (!this.response) {
        return [];
      }

      return this.response.questions;
    },

    vacancyName() {
      if (!this.response || !this.response.survey || !this.response.survey.length) {
        return '';
      }

      const answer = this.response.survey[0].answer.content || '';

      return answer.replace(/<[^>]*>?/gm, '');
    },
    // linkedinLink() {
    //   if (
    //     !this.response ||
    //     !this.response.survey ||
    //     this.response.survey.length < 4
    //   ) {
    //     return '';
    //   }

    //   let answer =
    //     this.response.survey[this.response.survey.length - 3].answer
    //       .content || '';

    //   return answer.replace(/<[^>]*>?/gm, '');
    // },
    // linkedinLinkText() {
    //   if (!this.linkedinLink) {
    //     return '';
    //   }
    //   let text = this.linkedinLink
    //     .replace(/^https?\:\/\//i, '')
    //     .replace(/^www\./i, '');
    //   return text;
    // },
    tabApplicationList() {
      if (!this.response || !this.response.survey || !this.response.survey.length) {
        return [];
      }
      let list = this.response.survey
        .filter((item, index) => index !== 0 && index <= this.response.survey.length - 4)
        .map((item, index) => {
          const name = item.question.name || '';
          const content = item.answer.content || '';
          return {
            id: index,
            title: name.replace(/<[^>]*>?/gm, ''),
            text: content.replace(/<[^>]*>?/gm, '')
          };
        });

      return list;
    },

    tabApplicationListHasAnswers() {
      if (!this.tabApplicationList || !this.tabApplicationList.length) {
        return false;
      }
      let hasAnswers = false;
      this.tabApplicationList.forEach(item => {
        if (item.text) {
          hasAnswers = true;
        }
      });
      return hasAnswers;
    },

    currentItem() {
      if (!this.questions || !this.questions.length) {
        return null;
      }
      return this.questions[this.questionIndex] ? this.questions[this.questionIndex] : null;
    },

    has_answers() {
      return this.response.questions.length > 0;
    },

    has_video_answers() {
      if (!this.response || !this.response.questions.length) {
        return false;
      }

      let has_video = false;
      this.questions.forEach(question => {
        if (question.video !== null) {
          has_video = true;
        }
      });
      return has_video;
    },

    is_playing() {
      return this.$store.getters['vacancy/videointerview/is_playing'];
    },

    candidate() {
      return this.response ? this.response.candidate : null;
    },

    candidatePhone() {
      return this.candidate ? this.candidate.phone : '';
    },

    candidateEmail() {
      return this.candidate ? this.candidate.email : '';
    },

    full_name() {
      if (!this.candidate) {
        return '';
      }
      return !this.is_japan_locale
        ? `${this.candidate.name} ${this.candidate.surname}`
        : `${this.candidate.name} ${this.candidate.surname}`;
    },

    lang() {
      if (!this.response || !this.response.vacancy || !this.response.vacancy.language) {
        return '';
      }

      return this.response.vacancy.language.code;
    },

    is_japan_locale() {
      return this.lang === 'ja';
    },

    tabAnswers() {
      return this.response && this.response.questions && this.response.questions.length > 0;
    },

    tabApplication() {
      return this.response && this.response.survey && this.response.survey.length > 0;
    },

    dummy_video_description() {
      return this.$tr('videoInterview.question.is_video_error');
    },

    is_video_started() {
      return this.$store.getters['interview/videointerview/is_video_started'];
    },

    first_click_was() {
      return this.$store.getters['interview/videointerview/first_click_was'];
    },

    questionIndex() {
      return this.$store.getters['vacancy/videointerview/index'];
    },

    video() {
      return this.selectedQuestion.video;
    },

    videoOrientaion() {
      if (
        !this.selectedQuestion ||
        !this.selectedQuestion.video ||
        !this.selectedQuestion.video.width ||
        !this.selectedQuestion.video.height
      ) {
        return 'horizontal';
      }
      const video = this.selectedQuestion.video;

      return video.width / video.height > 1 ? 'horizontal' : 'vertical';
    },

    videoWidthDefault() {
      if (!this.selectedQuestion || !this.selectedQuestion.video || !this.selectedQuestion.video.width) {
        return null;
      }
      return this.selectedQuestion.video.width;
    },

    videoHeightDefault() {
      if (!this.selectedQuestion || !this.selectedQuestion.video || !this.selectedQuestion.video.height) {
        return null;
      }
      return this.selectedQuestion.video.height;
    },

    videoHeight() {
      if (
        !this.selectedQuestion ||
        !this.selectedQuestion.video ||
        !this.selectedQuestion.video.width ||
        !this.selectedQuestion.video.height
      ) {
        return 'auto';
      }
      let proportion = 0;
      let height = 0;

      if (this.$refs.vblock) {
        this.blockWidth = this.$refs.vblock.offsetWidth;
      }

      this.$nextTick(() => {
        if (this.$refs.vblock) {
          this.blockWidth = this.$refs.vblock.offsetWidth;
        }
      });
      proportion = this.selectedQuestion.video.width / this.selectedQuestion.video.height;
      height = this.blockWidth / proportion;

      return height;
    },

    selectedQuestion() {
      let question = this.questions[this.questionIndex] ? this.questions[this.questionIndex] : {};

      return question;
    },

    autoPlay() {
      return this.$store.state.vacancy.videointerview.autoPlay;
    }
  },

  watch: {
    response: {
      immediate: true,
      handler(p, n) {
        if (!!p.id) {
          if (!!p.candidate) {
            document.title = `${this.full_name} - ${this.response.vacancy.name}`;
          }
        }
      }
    },

    questionIndex: {
      immediate: true,
      handler(val) {
        this.num = val;
        if (this.autoPlay && this.questions[val].video !== null) {
          this.play();
        }
        if (!this.questions[val].video) {
          this.loadedPlayer = true;
        }
        this.blockWidth = 0;
        this.currentTime = 0;
      }
    },

    is_playing(val) {
      if (val) {
        if (this.autoPlay) {
          this.$store.commit('vacancy/videointerview/setAutoPlay', false);
          this.play();
        }
      } else {
        if (this.autoPlay) {
          this.$store.commit('vacancy/videointerview/setAutoPlay', false);
          this.pause();
        }
      }
    },

    autoPlay(val) {
      if (val && this.questions[this.num].video !== null) {
        this.play();
      }
    },

    player_loadeddata(val) {
      if (val && this.is_playing) {
        this.play();
      }
    }
  },

  mounted() {
    this.vrdy();

    this.showPlayer();
    window.addEventListener('orientationchange', this.showPlayer);

    for (let i = 0; i < this.response.questions.length; i++) {
      if (this.response.questions[i].video !== null) {
        this.num = i;
        break;
      }
    }

    this.$store.commit('vacancy/videointerview/setIndex', this.num);
    this.$store.commit('response/setPublicResponse', this.response);

    this.loading = false;
    this.$emit('loaded');
    this.$nextTick(() => {
      setTimeout(() => {
        this.setScrollDetecting();
      }, 100);
    });
  },

  beforeDestroy() {
    this.$refs.tab_content.removeEventListener('scroll', this.scrollListener);
    window.removeEventListener('orientationchange', this.showPlayer);
  },

  methods: {
    showModal() {
      this.isModalVisible = true;
    },

    hideModal() {
      this.isModalVisible = false;
    },

    readyPlayer() {
      this.loadedPlayer = true;
    },

    player_state_changed(ev) {
      this.player_loadeddata = ev.loadeddata == true;
      if (ev.timeupdate) {
        this.currentTime = ev.timeupdate;
      }
    },

    onPlayerLoadeddata(player, index) {
      this.durations = [
        ...this.durations,
        {
          index,
          duration: player.duration()
        }
      ];
      this.loadedPlayer = true;
    },

    playerError(ev) {
      this.$emit('player_error', ev);
    },

    updateTab(id) {
      this.activeTab = this.tabs.find(item => item.id === id);
      this.tabChanged = true;
      this.$nextTick(() => {
        setTimeout(() => {
          this.setScrollDetecting();
        }, 100);
      });
    },

    set_answer_state(index, played) {
      if (this.num === index) {
        this.$store.commit('vacancy/videointerview/set_playing', played);
      }
    },

    save_config(data) {
      // volume, muted, rate
      this.config.volume = data.volume;
      this.config.muted = data.muted;
      this.config.rate = data.rate;
    },

    is_not_video(question) {
      return question.is_blocked || question.is_video_error || question.is_question_skipped;
    },

    first_play_click(val, current_index) {
      if (this.questions[val].video === null) {
        return;
      }

      if (this.is_video_started || this.first_click_was) {
        return;
      }
      // На iOs при первом клике на вопрос выполянется мгновенный play, затем pause и unmute всех видео вопросов.
      // Сделано, чтобы на iOs корректно отрабатывало автопереключение видео
      // if (this.isIos || this.isSafari) {

      let result = this.controls.find(control => control.index === val);
      if (result) {
        result.play();
      }

      if (this.num !== val) {
        if (result) {
          result.pause();
        }
      }
      this.playclick_count = this.playclick_count + 1;
      if (result !== null) {
        if (this.playclick_count === this.response.questions.length - 1) {
          this.$store.commit('interview/videointerview/set_first_click_was', true);
        }
        if (this.playclick_count >= this.response.questions.length) {
          this.$store.commit('interview/videointerview/toggle_start_video', true);
          this.$store.commit('vacancy/videointerview/setIndex', this.num);
        }
      }
    },

    next_answer() {
      if (!this.isIos && !this.isSafari) {
        let has_next_video = false;

        for (let i = this.num + 1; i <= this.response.questions.length - 1; i++) {
          if (this.response.questions[i].video !== null) {
            has_next_video = true;
          }
        }

        if (!has_next_video) {
          return;
        }

        if (this.num < this.response.questions.length - 1) {
          for (let i = this.num + 1; i < this.response.questions.length; i++) {
            if (this.response.questions[i].video !== null) {
              this.num = i;
              this.$store.commit('vacancy/videointerview/setIndex', this.num);
              setTimeout(() => {
                this.play();
              }, 100);
              break;
            }
          }
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      } else {
        const prev_control = this.controls.find(control => control.index === this.num);
        if (prev_control) {
          prev_control.pause();
        }

        let has_next_video = false;

        for (let i = this.num + 1; i <= this.response.questions.length - 1; i++) {
          if (this.response.questions[i].video !== null) {
            has_next_video = true;
          }
        }

        if (!has_next_video) {
          return;
        }

        if (this.num < this.response.questions.length - 1) {
          let result = this.controls.find(control => control.index === this.num + 1);
          if (result) {
            result.play(0); // time start 0
          } else {
            this.num++;
            return this.next_answer();
          }
          let has_video = false;
          for (let i = this.num + 1; i < this.response.questions.length; i++) {
            if (this.response.questions[i].video !== null) {
              has_video = true;
            }
          }
          if (has_video) {
            this.num++;
            if (result === null) {
              this.next_answer();
              return;
            }
            this.$store.commit('vacancy/videointerview/setIndex', this.num);
          }
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      }
    },

    prev_answer() {
      if (!this.isIos && !this.isSafari) {
        if (this.num > 0) {
          this.num--;
          let result = this.questions[this.num];
          if (result.video) {
            setTimeout(() => {
              this.play();
            }, 100);
          } else {
            return this.prev_answer();
          }
          this.$store.commit('vacancy/videointerview/setIndex', this.num);
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      } else {
        const prev_control = this.controls.find(control => control.index === this.num);
        if (prev_control) {
          prev_control.pause();
        }
        if (this.num > 0) {
          this.num--;
          let result = this.controls.find(control => control.index === this.num);
          if (result) {
            result.play(0); // time start 0
          } else {
            return this.prev_answer();
          }
          this.$store.commit('vacancy/videointerview/setIndex', this.num);
        } else {
          this.$store.commit('vacancy/videointerview/set_playing', false);
        }
      }
    },

    set_active_answer(num) {
      let time;
      let control;
      if (this.num !== num) {
        control = this.controls.find(control => control.index === this.num);
        if (control) {
          control.pause();
        }
        time = 0;
      }
      this.num = num;
      control = this.controls.find(control => control.index === this.num);
      if (control) {
        control.play_pause(time);
      }
    },

    set_controls(controls) {
      const index = controls.index;
      if (this.questions[index].video !== null) {
        this.controls.push(controls);
      }
    },

    vrdy() {
      var player_el, parent_el;
      if (window.innerWidth < 768 && (window.orientation === 0 || window.orientation === undefined)) {
        window.addEventListener('scroll', e => {
          if (window.orientation !== 90) {
            if (this.catched === false && this.top_poistion === null) {
              player_el = this.$refs.vblock;
              parent_el = player_el.parentElement;
              this.top_poistion = this.get_top(player_el);
            }

            if (window.scrollY >= this.top_poistion && this.catched === false) {
              parent_el.style.paddingTop = player_el.clientHeight + 20 + 'px';
              this.catched = true;
              player_el.style.position = 'fixed';
              player_el.style.zIndex = '99';
              player_el.style.left = '0';
              player_el.style.right = '0';
              player_el.style.top = '0';
              player_el.style.marginLeft = '0';
              player_el.style.marginRight = '0';
            }

            if (window.scrollY < this.top_poistion && this.catched) {
              this.catched = false;
              player_el.style.position = 'relative';
              parent_el.style.paddingTop = 0 + 'px';
              player_el.style.marginLeft = '-16px';
              player_el.style.marginRight = '-16px';
            }
          }
        });

        window.addEventListener('orientationchange', e => {
          if (window.orientation === 90) {
            this.catched = false;
            player_el.style.position = 'relative';
            parent_el.style.paddingTop = 0 + 'px';
            player_el.style.marginLeft = '-16px';
            player_el.style.marginRight = '-16px';
          }
        });
      }
    },

    get_top(o) {
      var y = 0;
      while (o !== null) {
        y = y + o.offsetTop;
        o = o.offsetParent;
      }
      return y;
    },

    nextQuestion(player) {
      if (this.num + 1 < this.questions.length) {
        this.$store.commit('vacancy/videointerview/setIndex', this.num + 1);
        this.play();
      } else {
        this.toggle_playing(false);
      }
    },

    toggle_playing(val) {
      this.$store.commit('vacancy/videointerview/set_playing', val);
    },

    indexChanged() {
      this.play();
    },

    pause() {
      setTimeout(() => {
        if (this.$refs.player) {
          this.$refs.player.$refs.video_block.player.pause();
          this.toggle_playing(false);
        }
      }, 100);
    },

    play() {
      setTimeout(() => {
        if (this.$refs.player) {
          this.$refs.player.$refs.video_block.player.play();
          this.toggle_playing(true);
        }
      }, 100);
    },

    change_playback_rate(rate) {
      this.defaultPlaybackRate = rate;
    },

    change_volume(v) {
      this.volume = v;
    },

    change_muted(v) {
      this.muted = v;
    },

    setScrollDetecting() {
      const $el = this.$refs.tab_content;

      if (!$el || $el.scrollHeight <= $el.offsetHeight) {
        this.hasContentScroll = false;
        return;
      } else {
        this.hasContentScroll = true;
      }
      this.$refs.tab_content.removeEventListener('scroll', this.scrollListener);

      $el.addEventListener('scroll', this.scrollListener);
    },

    scrollListener() {
      const $el = this.$refs.tab_content;

      if ($el.scrollTop + $el.offsetHeight >= $el.scrollHeight) {
        this.contentScrolledTo = 'bottom';
      }
      if ($el.scrollTop === 0) {
        this.contentScrolledTo = 'top';
      }
    },

    showPlayer() {
      if (!window.screen || window.screen.orientation === undefined) {
        VueScrollTo.scrollTo('#videoresume', 200);
        return;
      }
      const orientation = window.screen.orientation.angle || window.screen.orientation;

      if (orientation.angle !== 0 && orientation.angle !== 180) {
        VueScrollTo.scrollTo('#vblock', 200);
      } else {
        VueScrollTo.scrollTo('#videoresume', 200);
      }
    }
  }
};
</script>

<style src="./default.scss" lang="scss" scoped></style>
<style src="./default_media.scss" lang="scss" scoped></style>

<style lang="scss" scoped>
.videoresume {
  background: transparent;
  // min-height: calc(100vh - 98px);
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;

  .pub_page_wrapper {
    // flex: 1;
    // min-height: calc(100vh - 98px);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-start;
    margin: -2.875rem auto 0;
    padding: 46px 0 0;
    opacity: 0;

    &.pub_page__visible {
      opacity: 1;
      transition: opacity linear 0.3s;
    }

    @media only screen and (min-width: 1289px) and (max-height: 908px) {
      padding: 60px 0 0;
    }

    @media only screen and (max-width: 1288px) {
      min-width: calc(100% - 40px);
    }

    @media only screen and (min-width: 1025px) and (max-height: 870px) {
      padding: 56px 0 0;
    }

    @media only screen and (max-width: 1024px) {
      padding-bottom: 0;
      padding-top: 66px;
      min-width: auto;
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      min-width: 100%;
    }
  }

  .pub_page {
    flex: 1;
    display: grid;
    grid-template:
      [row1-start] 'header header' auto [row1-end]
      [row2-start] 'player info' 1fr [row2-end]
      / 640px 544px;
    column-gap: 24px;

    position: relative;
    box-sizing: border-box;
    // display: inline-flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    max-width: 1288px;
    min-width: 1288px;
    min-height: 646px;
    padding: 2.5rem;
    margin: 0 auto;
    background: #ffffff;
    box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.1);
    border-radius: 4px;

    &.pub_page-vertical {
      max-width: 1008px;
      min-width: 1008px;
      grid-template:
        [row1-start] 'player header' auto [row1-end]
        [row2-start] 'player info' 1fr [row2-end]
        / 360px 534px;
    }

    @media only screen and (max-width: 1288px) {
      grid-template:
        [row1-start] 'header header' auto [row1-end]
        [row2-start] 'player info' 1fr [row2-end]
        / 1fr 1fr;
      min-width: calc(100% - 40px);

      &.pub_page-vertical {
        max-width: 100%;
        min-width: 100%;
        grid-template:
          [row1-start] 'player header' auto [row1-end]
          [row2-start] 'player info' 1fr [row2-end]
          / 360px 1fr;
      }
    }

    @media only screen and (min-width: 1025px) and (max-height: 870px) {
      padding: 20px;
      min-height: auto;
    }

    @media only screen and (max-width: 1024px) {
      grid-template:
        [row1-start] 'header' [row1-end]
        [row2-start] 'player' [row2-end]
        [row2-start] 'info' [row2-end]
        / 640px;
      box-shadow: none;
      padding-top: 36px;
      margin: 0 auto;
      max-width: 640px;
      min-width: 100%;

      &.pub_page-vertical {
        grid-template:
          [row1-start] 'player header' auto [row1-end]
          [row2-start] 'player info' 1fr [row2-end]
          / 360px 1fr;
      }
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      grid-template:
        [row1-start] 'header' [row1-end]
        [row2-start] 'player' auto [row2-end]
        [row2-start] 'info' 1fr [row2-end]
        / 1fr;

      padding: 28px 16px 0;

      &.pub_page-vertical {
        grid-template:
          [row1-start] 'header' [row1-end]
          [row2-start] 'player' auto [row2-end]
          [row2-start] 'info' 1fr [row2-end]
          / 1fr;
      }
    }

    .vcontent {
      position: relative;
      margin: 0;
    }

    .vcontent-wrap {
      position: relative;
      margin-top: 20px;

      @media only screen and (max-width: 1024px) {
        margin-top: 20px;
      }
    }

    .vcontent--tabs {
      height: 430px;
      overflow: auto;
      transition: all linear 0.4s;

      &.has-scroll {
        &:not(.bottom) {
          -webkit-mask-image: -webkit-gradient(linear, left 60%, left bottom, from(black), to(rgba(0, 0, 0, 0)));
        }
        &.bottom {
          -webkit-mask-image: -webkit-gradient(linear, left 60%, left top, from(black), to(rgba(0, 0, 0, 0)));
        }

        @media only screen and (max-width: 1024px) {
          &:not(.bottom) {
            -webkit-mask-image: none;
          }
          &.bottom {
            -webkit-mask-image: none;
          }
        }
      }

      @media only screen and (min-width: 1025px) and (max-height: 870px) {
        height: 396px;
      }

      @media only screen and (max-width: 1024px) {
        height: auto;
      }
    }

    .videoresume-header {
      margin-bottom: 2rem;

      @media only screen and (max-width: 1024px) {
        margin-bottom: 4px;
      }

      @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
        margin-bottom: 20px;
      }

      .name {
        font-style: normal;
        font-weight: bold;
        font-size: 2rem;
        line-height: 2.5rem;
        color: #555;
        margin-bottom: 0.25rem;

        @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
          font-size: 24px;
          line-height: 1;
          margin-bottom: 8px;
        }
      }

      .vacancy_name {
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 1.5rem;
        color: #8d8d8d;
        margin-bottom: 0;

        @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
          line-height: 19px;
        }
      }
    }

    &.pub_page-vertical {
      .videoresume-header {
        margin-bottom: 40px;

        @media only screen and (max-width: 1024px) {
          margin-bottom: 2rem;
        }
      }
    }
  }

  .videoresume-top {
    display: flex;
    justify-content: center;
    width: 100%;
    position: relative;
    max-width: 1288px;
    min-width: 1288px;

    @media only screen and (max-width: 1288px) {
      min-width: calc(100% - 40px);
    }

    @media only screen and (max-width: 1024px) {
      max-width: 100%;
      min-width: 100%;
    }

    &.videoresume-top--vertical {
      max-width: 1008px;
      min-width: 1008px;

      @media only screen and (max-width: 1288px) {
        max-width: 100%;
        min-width: 100%;
      }
    }
  }

  .videoresume-content {
    display: flex;
    justify-content: space-between;
  }

  .videoresume-logo {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;

    @media only screen and (min-width: 1025px) and (max-height: 870px) {
      margin-bottom: 10px;
    }

    @media only screen and (max-width: 1024px) {
      margin-bottom: 0;
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      height: 24px;
    }

    img {
      max-height: 30px;
    }
  }

  .videoresume-date {
    position: absolute;
    right: 0;
    bottom: 0.25rem;
    // font-family: 'Euclid Circular A';
    font-style: normal;
    font-weight: normal;
    font-size: 0.75rem;
    line-height: 1rem;
    color: #8d8d8d;

    @media only screen and (max-width: 1024px) {
      display: none;
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      // font-family: 'Euclid Circular A';
      font-style: normal;
      font-weight: normal;
      font-size: 10px;
      line-height: 146.48%;
      color: #c4b9d3;
    }

    &.videoresume-date--mobile {
      display: none;

      @media only screen and (max-width: 1024px) {
        display: block;
        width: 100%;
        top: -20px;
        height: auto;
        bottom: auto;
        text-align: right;
      }
    }
  }

  .pub_page-vertical {
    .videoresume-date.videoresume-date--mobile {
      @media only screen and (max-width: 1024px) {
        text-align: left;
      }
      @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
        text-align: right;
      }
    }
  }

  .contacts_block {
    padding: 0;
    // font-family: 'Euclid Circular A';
    font-size: 15px;
    line-height: 24px;
    color: #8d8d8d;
  }

  ::v-deep {
    .video-js {
      @media only screen and (min-width: 1025px) {
        background: transparent;
      }
    }
  }

  .loading,
  .error {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    width: 100%;
  }
}

.videoresume-modal__h {
  margin-bottom: 12px;
  // font-family: 'Euclid Circular A';
  font-style: normal;
  font-weight: bold;
  font-size: 17px;
  line-height: 24px;
  color: #555555;
}

.videoresume-modal__list {
  list-style: none;
  padding-left: 4px;
}

.videoresume-modal__item {
  margin-bottom: 1rem;
  display: flex;
  // font-family: 'Euclid Circular A';
  font-style: normal;
  font-weight: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 24px;
  color: #8d8d8d;

  &:last-child {
    margin-bottom: 0;
  }

  a {
    span {
      text-overflow: ellipsis;
      max-width: 284px;
      overflow: hidden;
    }
  }
}

.videoresume-modal__link {
  display: flex;
  align-items: center;
  cursor: pointer;

  &:hover,
  &:active {
    transition: color 0.35s ease;
    background: linear-gradient(278deg, #535dc1 0%, #a364d6 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;

    span {
      background: linear-gradient(278deg, #535dc1 0%, #a364d6 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
}

.videoresume-modal__icon {
  margin-right: 0.5rem;
  width: 1.5rem;
  display: flex;
  align-items: center;
}

.videoresume-nav {
  display: flex;
  align-items: center;
  width: 100%;
}

.top-tabs {
  margin-top: 0 !important;
}

.videoresume-contacts {
  margin-left: auto;

  &.cv-row a.cv-row-resume-link:not(:last-child) {
    margin-right: 0.5rem;
  }

  @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
    display: none;
  }
}

.videoresume-footer {
  display: flex;
  justify-content: flex-end;

  @media only screen and (max-width: 1024px) {
    ::v-deep {
      .v-resume-button {
        width: 100%;
        box-sizing: border-box;
        position: static;
      }
    }
  }

  @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
    margin-top: 20px;
  }
}

.pub_page-vertical {
  .videoresume-footer {
    @media only screen and (max-width: 1024px) {
      position: absolute;
      bottom: 0;
      left: 40px;
      width: calc(100% - 80px);
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      position: static;
      width: 100%;
    }
  }
}

.videoresume-footer__button {
  position: absolute;
  bottom: 40px;
  right: 40px;

  @media only screen and (min-width: 1025px) and (max-height: 870px) {
    bottom: 20px;
    right: 20px;
  }
}

.videoresume-content-hidden {
  width: 100%;
  height: 80px;
  overflow: hidden;
  opacity: 0;
}

.videoresume-header {
  grid-area: header;
}

.videoresume-left-block {
  grid-area: player;

  @media only screen and (max-width: 1024px) {
    margin-bottom: 20px;
  }

  @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
    margin-bottom: 16px;
  }
}

.videoresume-right-block {
  grid-area: info;
  margin-bottom: 56px;

  @media only screen and (max-width: 1024px) {
    margin-bottom: 0;
  }
}

.pub_page-vertical {
  .videoresume-left-block,
  .videoresume-right-block {
    @media only screen and (max-width: 1024px) {
      padding-bottom: 66px;
    }

    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      padding-bottom: 0;
    }
  }
}

.response-player {
  border-radius: 4px;
  overflow: hidden;

  &:not(.vphide) {
    @media only screen and (max-width: 480px), only screen and (max-width: 1000px) and (orientation: landscape) {
      border-radius: 0;
    }

    @media only screen and (max-width: 1000px) and (orientation: landscape) {
      height: 100vh;

      ::v-deep {
        .video-player,
        .video-js {
          height: 100vh;
          padding: 0;
          width: 100vw;
        }
      }
    }
  }

  &.response-player-safari:not(.vphide) {
    &.response-player-vertical {
      &.response-player {
        width: 360px;
        min-height: 480px;
        margin: 0 auto;

        ::v-deep .video-js {
          min-height: 480px;
        }

        @media only screen and (max-width: 1000px) and (orientation: landscape) {
          height: 100vh;
          width: 100vw;

          ::v-deep {
            .video-player,
            .video-js {
              height: 100vh;
              padding: 0;
              width: 100vw;
            }
          }
        }

        @media only screen and (max-width: 480px) {
          width: auto;

          ::v-deep {
            .video-player,
            .video-js {
              min-height: auto;
            }
          }
        }
      }
    }
  }
}

.vblock {
  position: relative;

  @media only screen and (max-width: 480px),
    only screen and (max-width: 1000px) and (orientation: landscape) {
    margin-left: -16px;
    margin-right: -16px;
  }
}

.cv-row-mobile {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.cv-row-mobile__text {
  display: block;
  // font-family: 'Euclid Circular A';
  font-style: normal;
  font-weight: normal;
  font-size: 15px;
  line-height: 24px;
  color: #8d8d8d;
  word-break: break-word;
}

.cv-row-mobile__file {
  margin-right: 8px;
  width: 20px;
  min-width: 20px;
}

.cv-row-mobile__link {
  margin-right: 2px;
  width: 24px;
  min-width: 24px;
}
</style>
